import { getGameSession as getGameSessionFromWeb } from '@tencent/game-session-web-sdk';

const getGameSessionFromEvo = () => vn.external.getWxGameSession?.() || '';

const APP_ID = 2;
const APP_KEY = '11a72f16f145215e';

const getGameSessionStr = () => {
  if (import.meta.env.EVO) {
    return getGameSessionFromEvo();
  }

  if (import.meta.env.SSR) {
    return '';
  }

  return getGameSessionFromWeb({
    appid: APP_ID,
    appKey: APP_KEY,
  });
};

export const getGameSession = () => {
  const data = getGameSessionStr();
  if (!data) {
    return [];
  }

  try {
    return JSON.parse(data);
  } catch {
    return [];
  }
};
